import { StorageNameDataType } from "./storageNameTypes";

export const getStorageName: StorageNameDataType = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
  currentBrand: "current_brand",
  currentOrganization: "current_organization",
};
